import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { ProviderListComponent } from './provider-list.component'

const PROVIDER_LIST_ROUTES: Routes = [{
    path: '', component: ProviderListComponent
}];

export const PROVIDER_LIST_ROUTING  = RouterModule.forChild(PROVIDER_LIST_ROUTES);